import { render } from "./App.vue?vue&type=template&id=7357b7b8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7357b7b8&lang=css"
import "./App.vue?vue&type=style&index=1&id=7357b7b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7357b7b8"]])

export default __exports__